import { showBackofficeFlash } from "packs/init-backoffice-flashes"

const copyText = async (text) => {
  if (!text) return false

  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (_err) {
      // fallback below
    }
  }

  const textarea = document.createElement("textarea")
  textarea.value = text
  textarea.setAttribute("readonly", "")
  textarea.style.position = "fixed"
  textarea.style.top = "-9999px"
  document.body.appendChild(textarea)
  textarea.select()
  let ok = false
  try {
    ok = document.execCommand("copy")
  } catch (_err) {
    ok = false
  }
  textarea.remove()
  return ok
}

const copyFromEvent = async (event) => {
  if (event.target.closest("a")) return

  const btn = event.target.closest(".backoffice-copy-btn")
  const inline = event.target.closest(".backoffice-copyable-inline.is-copyable")
  const row = event.target.closest(".backoffice-definition-list__row.is-copyable")
  const block = event.target.closest(".backoffice-copyable-block.is-copyable")
  if (!btn && !inline && !row && !block) return

  const value =
    btn?.dataset?.copyValue ||
    inline?.querySelector(".backoffice-copy-btn")?.dataset?.copyValue ||
    (row?.querySelector(".backoffice-copy-btn") || block?.querySelector(".backoffice-copy-btn"))
      ?.dataset?.copyValue
  if (!value) return

  event.preventDefault()
  const ok = await copyText(value)
  showBackofficeFlash(ok ? "Copié" : "Impossible de copier", ok ? "notice" : "alert")
}

export const initBackofficeCopy = () => {
  if (document.documentElement.dataset.backofficeCopyInit === "true") return
  document.documentElement.dataset.backofficeCopyInit = "true"

  document.addEventListener("click", copyFromEvent)
}
